(() => {
  const revealSelector = [
    ".origin-overview",
    ".craft-card",
    ".origin-closing",
    ".manifesto-content",
    ".atelier-content",
    ".playful-content",
    ".japan-content"
  ].join(", ");

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initRevealEffects(scope = document) {
    const revealTargets = scope.querySelectorAll(revealSelector);

    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealTargets.forEach((target) => {
        target.classList.add("reveal", "is-visible");
        target.dataset.lusupRevealReady = "true";
      });
      return;
    }

    document.body.classList.add("effects-ready");

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: "0px 0px -7%"
    });

    revealTargets.forEach((target) => {
      if (target.dataset.lusupRevealReady === "true") return;
      target.dataset.lusupRevealReady = "true";
      target.classList.add("reveal");
      revealObserver.observe(target);
    });
  }

  function initAmbientLight() {
    const ambientLight = document.querySelector(".ambient-light");
    const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (!ambientLight || !finePointer || reduceMotion) return;
    if (ambientLight.dataset.lusupAmbientReady === "true") return;

    ambientLight.dataset.lusupAmbientReady = "true";

    let pointerFrame = 0;
    let pointerX = -700;
    let pointerY = -700;

    window.addEventListener("pointermove", (event) => {
      pointerX = event.clientX;
      pointerY = event.clientY;
      document.body.classList.add("pointer-active");

      if (pointerFrame) return;

      pointerFrame = window.requestAnimationFrame(() => {
        ambientLight.style.transform = `translate3d(${pointerX - 260}px, ${pointerY - 260}px, 0)`;
        pointerFrame = 0;
      });
    }, { passive: true });

    document.documentElement.addEventListener("mouseleave", () => {
      document.body.classList.remove("pointer-active");
    });
  }

  function initAboutPage(scope = document) {
    initRevealEffects(scope);
    initAmbientLight();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAboutPage(), { once: true });
  } else {
    initAboutPage();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAboutPage(event.target);
  });
})();
